module.exports = __webpack_public_path__ + "static/media/270146.7c5e920f.png";